import { Component, OnInit } from '@angular/core';
import {CommonModalBase} from "../common/commonModalBase.abstract";
import {ModalStatementInterface} from "./modal-statement.interface";
import {CommonModalService} from "../../common-modal/common-modal.service";
import {CommonModalTemplatesEnum} from "../all-modals-config";

@Component({
  selector: 'v-modal-statement',
  templateUrl: './modal-statement.component.html'
})
export class ModalStatementComponent extends CommonModalBase<ModalStatementInterface> {

  constructor(
    commonModalService: CommonModalService
  ) {
    super(
      commonModalService,
      CommonModalTemplatesEnum.STATEMENT
    );
  }

  submitFunc(event: MouseEvent): void {
    if (this.modalData && typeof this.modalData.submitBtn === 'function') {
      this.modalData.submitBtn(event)
    }
  }
}
